import { TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { Caption } from '@sorare/core/src/atoms/typography';
import { MyClubLink } from '@sorare/core/src/components/user/MyClubLink';
import UserName from '@sorare/core/src/components/user/UserName';

import { ItemUser_user } from './__generated__/index.graphql';

export interface Props {
  item: ItemUser_user;
}

const Root = styled(Caption)`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const ItemUser = ({ item }: Props) => {
  const user = item;

  return (
    <Root title={user.nickname} color="var(--c-neutral-600)" bold>
      <MyClubLink user={user}>
        <UserName user={user} />
      </MyClubLink>
    </Root>
  );
};

ItemUser.fragments = {
  user: gql`
    fragment ItemUser_user on User {
      slug
      ...MyClubLink_publicUserInfoInterface
      ...UserName_publicUserInfoInterface
    }
    ${MyClubLink.fragments.user}
    ${UserName.fragments.user}
  ` as TypedDocumentNode<ItemUser_user>,
};

export default ItemUser;
